<div class="td-wb-detailed-quote-message">
  @if (!hideHeader()) {
    <div class="td-wb-detailed-quote-message__header">
      <div class="td-wb-detailed-quote-message__link">
        <span [innerText]="symbol().market | uppercase"></span>&nbsp;:&nbsp;<span
        [innerText]="symbol().tickerSymbol | uppercase"></span>
      </div>
    </div>
  }
  <div class="td-wb-detailed-quote-message__content">
    <div class="td-wb-detailed-quote-message__wrap"
         [title]="'tdWb.markets.quote.ATTENTION' | tdWbTranslate">
      <!-- ErrorMessage -->
      @if (template() === 'errorMessage') {
        <td-wb-notification *tdWbIfNoFeature="'simplfiedErrorsExpandedQuote'"
                            notificationType="error">
          <div class="td-wb-detailed-quote-message__red">
            <span translate="tdWb.markets.quote.unknownerror.INFORMATION_NOT_AVAILABLE"></span>
            <span translate="tdWb.markets.quote.unknownerror.PLEASE_TRY_AGAIN_LATER"></span>
          </div>
        </td-wb-notification>
        <td-wb-empty *tdWbIfFeature="'simplfiedErrorsExpandedQuote'">
          <td-wb-icon tdWbEmptyIcon
                      iconId="circle-info"
                      size="60x60" />
          <td-wb-empty-header translate="tdWb.markets.quote.unknownerror.TEMPORARILY_UNAVAILABLE" />
          <td-wb-empty-sub-header translate="tdWb.markets.quote.unknownerror.SEE_CURRENT_PRICE" />
        </td-wb-empty>
      }

      <!-- UnknownSymbol -->
      @if (template() === 'unknownSymbol') {
        <td-wb-notification *tdWbIfNoFeature="'simplfiedErrorsExpandedQuote'"
                            notificationType="error">
          <div class="td-wb-detailed-quote-message__red">
            <span translate="tdWb.markets.quote.unknownsymbol.SYMBOL_IS_NOT_VALID"></span>
          </div>
        </td-wb-notification>
        <td-wb-empty *tdWbIfFeature="'simplfiedErrorsExpandedQuote'">
          <td-wb-empty-header translate="tdWb.markets.quote.unknownsymbol.SECURITY_DETAILS_UNAVAILABLE" />
          <td-wb-empty-sub-header translate="tdWb.markets.quote.unknownsymbol.SEE_CURRENT_PRICE" />
        </td-wb-empty>
      }

      <!-- NoPermission Message -->
      @if (template() === 'noPermission') {
        <td-wb-notification notificationType="warning">
          <div>
            <span translate="tdWb.markets.quote.quoteunpermitted.MESSAGE_START"></span>&nbsp;
            <a class="td-wb-link"
               tdWbHref="link_preferences_agreements">
              <span translate="tdWb.markets.quote.quoteunpermitted.CLICK_HERE"></span>
            </a>&nbsp;
            <span translate="tdWb.markets.quote.quoteunpermitted.MESSAGE_END"></span>
          </div>
        </td-wb-notification>
        <!-- NoPermission Content -->
        @if (tradeInfo() !== undefined) {
          <div class="td-wb-detailed-quote-message__action">
            <td-wb-buy-sell-buttons type="primary"
                                    size="regular"
                                    [tradeInfo]="tradeInfo()" />
          </div>
        }
      }
    </div>
  </div>
</div>
